import { defineStore } from 'pinia';
import quoteService from './api';
import type { PayloadBibliographyLink, TChoices } from './types';

interface State {
	choices: TChoices['choices'];
	link: string;
}

export const useDialogQuoteStore = defineStore('DialogQuote', {
	state: (): State => ({
		choices: [],
		link: '',
	}),

	getters: {
		linkFormats: ({ choices }) => {
			return choices.map(([id, value]) => ({ id, value }));
		},
	},

	actions: {
		async getBibliographyLinkFormats() {
			const data = await quoteService.fetchBibliographyLinkFormats();

			if ('error' in data) {
				console.error(data);
				return null;
			}

			this.choices = data.choices;
		},

		async getBibliographyLink(payload: PayloadBibliographyLink) {
			const data = await quoteService.fetchBibliographyLink(payload);

			if ('error' in data) {
				console.error(data);
				return null;
			}

			this.link = data.link;
		},
	},
});
